export default __webpack_public_path__ + "static/media/020-lotus temple.f754c6b7.svg";